/* Nuclever: carruseles (galería, antes/después, reseñas) y rotación de anuncios en mobile. */
(function () {
  function iniciarCarrusel(raiz) {
    if (raiz.dataset.ncListo) return;
    raiz.dataset.ncListo = '1';
    var pista = raiz.querySelector('[data-nc-pista]');
    if (!pista) return;
    var items = Array.prototype.slice.call(pista.children);
    var miniaturas = raiz.querySelectorAll('[data-nc-ir]');
    var puntos = raiz.querySelector('.nc-puntos');
    var circular = raiz.hasAttribute('data-nc-circular');

    if (puntos) {
      items.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir a la ' + (i + 1));
        b.addEventListener('click', function () { ir(i); });
        puntos.appendChild(b);
      });
    }

    function actual() {
      var izq = pista.scrollLeft, mejor = 0, dist = Infinity;
      items.forEach(function (el, i) {
        var d = Math.abs(el.offsetLeft - pista.offsetLeft - izq);
        if (d < dist) { dist = d; mejor = i; }
      });
      return mejor;
    }
    function ir(i) {
      if (circular) i = (i + items.length) % items.length;
      i = Math.max(0, Math.min(items.length - 1, i));
      pista.scrollTo({ left: items[i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
    }
    function marcar() {
      var i = actual();
      miniaturas.forEach(function (m) { m.classList.toggle('is-activo', +m.dataset.ncIr === i); });
      if (puntos) Array.prototype.forEach.call(puntos.children, function (p, j) { p.classList.toggle('is-activo', j === i); });
    }
    raiz.querySelectorAll('[data-nc-prev]').forEach(function (b) { b.hidden = false; b.addEventListener('click', function () { ir(actual() - 1); }); });
    raiz.querySelectorAll('[data-nc-next]').forEach(function (b) { b.hidden = false; b.addEventListener('click', function () { ir(actual() + 1); }); });
    miniaturas.forEach(function (m) {
      m.addEventListener('click', function () {
        ir(+m.dataset.ncIr);
        m.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });
    var t;
    pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(marcar, 60); }, { passive: true });
    marcar();
  }

  function iniciarAnuncios(raiz) {
    var items = raiz.querySelectorAll('.nc-anuncios__item');
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('is-activo');
    setInterval(function () {
      items[i].classList.remove('is-activo');
      i = (i + 1) % items.length;
      items[i].classList.add('is-activo');
    }, 4000);
  }

  // Fecha de entrega estimada: hoy + días hábiles (lunes a viernes) del operador. Feriados no se descuentan.
  function sumarHabiles(fecha, dias) {
    var f = new Date(fecha.getTime());
    while (dias > 0) { f.setDate(f.getDate() + 1); if (f.getDay() !== 0 && f.getDay() !== 6) dias--; }
    return f;
  }
  function iniciarEntrega(el) {
    if (el.dataset.ncListo) return; el.dataset.ncListo = '1';
    var dias = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var fmt = function (f) { return dias[f.getDay()] + ' ' + f.getDate() + '/' + (f.getMonth() + 1); };
    var hoy = new Date();
    var texto = (el.dataset.texto || '')
      .replace('[desde]', fmt(sumarHabiles(hoy, parseInt(el.dataset.min, 10) || 5)))
      .replace('[hasta]', fmt(sumarHabiles(hoy, parseInt(el.dataset.max, 10) || 7)));
    var destino = el.querySelector('[data-nc-entrega-texto]');
    if (destino && texto) destino.innerHTML = texto;
  }

  // Aviso de stock (pedido del usuario, 09-oct): número al azar por sesión; la misma persona ve en cada sesión nueva
  // un número más bajo que en la anterior (baja de 1 a 3, sin pasar del piso). Se guarda en el navegador.
  function iniciarUrgencia(el) {
    if (el.dataset.ncListo) return; el.dataset.ncListo = '1';
    var min = parseInt(el.dataset.min, 10) || 25, max = parseInt(el.dataset.max, 10) || 38, piso = parseInt(el.dataset.piso, 10) || 3;
    var n = null, prev = null;
    try { n = parseInt(sessionStorage.getItem('nc_stock'), 10); } catch (e) {}
    if (!(n > 0)) {
      try { prev = parseInt(localStorage.getItem('nc_stock'), 10); } catch (e) {}
      n = prev > 0 ? Math.max(piso, prev - 1 - Math.floor(Math.random() * 3)) : min + Math.floor(Math.random() * (max - min + 1));
      try { sessionStorage.setItem('nc_stock', n); localStorage.setItem('nc_stock', n); } catch (e) {}
    }
    var destino = el.querySelector('[data-nc-urgencia-n]');
    if (destino) destino.textContent = n;
    el.hidden = false;
  }

  function iniciar() {
    document.querySelectorAll('[data-nc-urgencia]').forEach(iniciarUrgencia);
    document.querySelectorAll('[data-nc-carrusel]').forEach(iniciarCarrusel);
    document.querySelectorAll('[data-nc-entrega]').forEach(iniciarEntrega);
    document.querySelectorAll('.nc-anuncios').forEach(function (a) {
      if (!a.dataset.ncListo) { a.dataset.ncListo = '1'; iniciarAnuncios(a); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
